import { API_BASE_URL } from '../../common/utils/commonUrl'
import http from '../../common/utils/http'
import apiUtils from '../../common/utils/apiUtils'
import * as DictionaryConstants from '../../constants/DictionaryConstants'

const api = {
  getSelectedDetails: (code) => {
    return api.getDictInfosByTypeCode(code)
  },
  getAllSysCustomerData: () => {
    return http.get(API_BASE_URL + '/api/sys/employee/all').then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        return res
      }
    )
  },
  getAllOrgs: async () => {
    const orgs = await api.getDictInfosByTypeCode(DictionaryConstants.DEPARTMENT_INFO)
    if (!orgs || !orgs.length) {
      return []
    }

    return orgs.map(org => {
      const parts = org.label.split('@@')
      const label = parts[0]
      const address = parts.length > 1 ? parts[1] : label
      return {
        ...org,
        label,
        address
      }
    })
  },
  getReservationCustomerByCode: (code) => {
    return http.get(API_BASE_URL + '/api/sys/employee/role/code/' + code).then(
      function (res) {
        let dictDataList = apiUtils.getDataFormResponse(res)
        utils.dictSort(dictDataList, (a, b) => a - b)
        return dictDataList
      },
      function (res) {
        return res
      }
    )
  },
  getDictInfosByTypeCode (typeCode) {
    return http.get(API_BASE_URL + '/api/dict/typeCode/' + typeCode)
      .then(res => {
        let dictDataList = apiUtils.getDataFormResponse(res)
        utils.dictSort(dictDataList, (a, b) => a - b)
        return dictDataList
      })
  },
  getDictInfoByTypeCodeAndDictCode (typeCode, dictCode) {
    return http.get(API_BASE_URL + '/api/dict/typeCode/' + typeCode + '/dictCode/' + dictCode)
      .then(res => {
        return apiUtils.getDataFormResponse(res)
      })
  },
  getDictInfosByTypeCodes (codes) {
    return Promise.all(codes.map(code => {
      return this.getDictInfosByTypeCode(code)
        .then(dicts => {
          const dictData = dicts.reduce((prevs, dict) => ({ ...prevs, ...{ [dict.value]: dict.label } }), {})
          return { [code]: dictData }
        })
    })).then(fieldFullDefs => {
      let data = {}
      // TODO reduce 使用 cache前端缓存可配置调用时间
      fieldFullDefs.forEach(fieldFullDef => {
        data = { ...data, ...fieldFullDef }
      })
      return data
    })
  },
  getCarTypeByBrand: (condition) => {
    return http.get(`${API_BASE_URL}/api/dict/parent/typeCode/memberVehicleBrands/dictCode/${condition}`).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  updateCarDetails: (condition) => {
    return http.post(`${API_BASE_URL}/api/wxoa/member/member/patchMemberCar`, condition).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  memberAuthentication: (condition) => {
    // wxoa/member/member/verificationUserMember
    return http.post(`${API_BASE_URL}/api/wxoa/member/member/verificationMember`, condition).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  updateMemberDetailsById: (condition) => {
    return http.patch(`${API_BASE_URL}/api/wxoa/member/member/patchMemberInfo`, condition).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  }
}
const utils = {
  dictSort (arr, fn) {
    let len = arr.length
    while (len--) {
      for (let i = 0; i < len; i++) {
        if (fn(arr[i].sort, arr[i + 1].sort) > 0) {
          [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]]
        }
      }
    }
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/dict/dictionary-api.js